import { useMemo, useState } from "react";
import { getEmployeeList } from "src/apis/employeeApi";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { formatDate } from "src/utils/string/stringUtil";
import { defaultKSK1110_R01DetailDto } from "./Dto_KSK1110_R01";
import { useKSK1110_R01Store } from "./Store_KSK1110_R01";

export const Info_KSK1110_R01 = () => {
	const { setCodeSearchModalProps } = useUiuxStore();
	const {
		selectedKSK1110_R01,
		editKSK1110_R01,
		setEditKSK1110_R01,
	} = useKSK1110_R01Store();
	const [inspectDateVisible, setInspectDateVisible] = useState(false);
	const [inspectDatePickerPos, setInspectDatePickerPos] = useState({ top: 0, left: 0, height: 0 });

	const infoFieldConfigs = useMemo<InfoCodeSearchFieldConfig[]>(() => [
		{
			fieldName: "inspectorEmp",
			category: "담당자",
			focusId: "KSK1110_R01-inspector",
			responseMapping: { empNo: "inspectorEmp", empNm: "inspectorEmpNm" },
			searchFunction: async (code: string) => {
				const response = await getEmployeeList("all");
				return response.data.data.find((employee) => employee.empNo === code);
			},
		},
		{
			fieldName: "approvorEmpno",
			category: "담당자",
			focusId: "KSK1110_R01-approver",
			responseMapping: { empNo: "approvorEmpno", empNm: "approvorEmpNm" },
			searchFunction: async (code: string) => {
				const response = await getEmployeeList("all");
				return response.data.data.find((employee) => employee.empNo === code);
			},
		},
	], []);

	const { getFieldHandlers } = useInfoFormEvents({
		editData: editKSK1110_R01,
		setEditData: setEditKSK1110_R01,
		defaultData: defaultKSK1110_R01DetailDto,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: "KSK1110_R01",
	});

	return (
		<div className="w-full h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] pb-[6px] overflow-y-auto border border-gray-300 bg-white">
			<InputForm title="검사구분" name="inspectType" value="수입검사" editable={false} />
			<InputForm title="거래처" name="customNm" value={selectedKSK1110_R01?.customNm ?? ""} editable={false} />
			<InputForm title="품목" name="itemNm" value={editKSK1110_R01.itemNm || selectedKSK1110_R01?.itemNm || ""} editable={false} />
			<InputForm title="LotNo" name="lotNo" value={editKSK1110_R01.basLotNo || selectedKSK1110_R01?.lotNo || ""} editable={false} />
			<CodeForm
				label="검사자"
				value={editKSK1110_R01.inspectorEmp}
				custNmValue={editKSK1110_R01.inspectorEmpNm}
				editable={Boolean(selectedKSK1110_R01)}
				handleFoucsId="KSK1110_R01-inspector"
				name="inspectorEmp"
				handleChange={getFieldHandlers("inspectorEmp").onChange}
				onDoubleClick={getFieldHandlers("inspectorEmp").onDoubleClick}
				onKeyDown={getFieldHandlers("inspectorEmp").onEnterKeyDown}
			/>
			<CodeForm
				label="승인자"
				value={editKSK1110_R01.approvorEmpno}
				custNmValue={editKSK1110_R01.approvorEmpNm}
				editable={Boolean(selectedKSK1110_R01)}
				handleFoucsId="KSK1110_R01-approver"
				name="approvorEmpno"
				handleChange={getFieldHandlers("approvorEmpno").onChange}
				onDoubleClick={getFieldHandlers("approvorEmpno").onDoubleClick}
				onKeyDown={getFieldHandlers("approvorEmpno").onEnterKeyDown}
			/>
			<SingleDateForm
				title="검사일자"
				value={editKSK1110_R01.inspectDt ? new Date(editKSK1110_R01.inspectDt) : undefined}
				setValue={(inspectDt) => setEditKSK1110_R01({ ...editKSK1110_R01, inspectDt: formatDate(inspectDt) })}
				editable={Boolean(selectedKSK1110_R01)}
				visible={inspectDateVisible}
				setVisible={setInspectDateVisible}
				pickerPos={inspectDatePickerPos}
				setPickerPos={setInspectDatePickerPos}
			/>
		</div>
	);
};
